import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDocumentModule } from "./learningAPI";

export interface DocumentModState {
  documentmodule: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DocumentModState = {
    documentmodule: [],
  status: "idle",
};

export const GetDocumentModule = createAsyncThunk(
  "document/fetchDocument",
  async (data:any) => {
    const response = await fetchDocumentModule(data);
    return response;
  }
);

export const documentModuleSlice = createSlice({
  name: "Document",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDocumentModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDocumentModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetDocumentModule.fulfilled, (state, action) => {
        state.status = "idle";
        state.documentmodule = action.payload.material;
        //console.log(action.payload.material,"action.payload.material;")
        //state.documentmodule = state.documentmodule.concat(action.payload.material);
      });
  },
});

export const {} = documentModuleSlice.actions;

export const selectDocumentModule = (state: RootState) => {
  return state.DocumentModule.documentmodule;
};

export default documentModuleSlice.reducer;
